import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { loader_selector } from 'src/app/store/app.selectors';

@Component({
  selector: 'app-loading-screen',
  templateUrl: './loading-screen.component.html',
  styleUrls: ['./loading-screen.component.scss']
})
export class LoadingScreenComponent implements OnInit {


  is_loader_displayed: boolean = true; 


  constructor(
    private store: Store
  ) { }

  ngOnInit(): void 
  {
    this.listen_to_states();
  }




  listen_to_states()
  {

    this.store.select( loader_selector ).subscribe(
      (state: any)=>{
        this.is_loader_displayed = state;
      }
    );


  }




}
